import React, {useContext, useEffect, useState} from "react";
import {Button, Modal, Nav, Spinner, Tab} from "react-bootstrap";
import moment from "moment-jalaali";
import {MessageContext} from "./MessageContext";
import CommentDetals from "./modals/CommentDetals";
import SendingPictures from "./modals/SendingPictures";
import Report from "./modals/Report";
import Sharing from "./modals/Sharing";
import {
  addBookmark,
  disLikeFeedback,
  getFeedback,
  likeFeedback,
  removeBookmark,
} from "../../controlers/messages/FeedbackController";
import {ToastContext} from "../../component/global/ToastContext";
import UserPic from "../../asset/icons/accountIcon.svg";
import {get, post} from "../../controlers/global/ConfigRequest";
import {
  FEEDBACK_STATUS_LIST,
  FEEDBACK_STATUS_LIST_ASSIGN_GROUPS,
  FEEDBACK_STATUS_PICKUP,
  FEEDBACK_STATUS_WORKFLOW,
} from "../../helperData/ApiAddress";
import {GlobalStateContext} from "../../layouts/GlobalStates";
import ScoreModal from "./ScoreModal";
import {useTranslation} from "react-i18next";
import {collectFeedbackFiles} from "../../utils/mediaUrl";
import {
  isMessageDetailReady,
  shouldFetchMessageDetail,
} from "./messageModalReady";

const ThumbUpIcon = ({filled}) => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"}
       stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 10v12M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>
  </svg>
);

const ThumbDownIcon = ({filled}) => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"}
       stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 14V2M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"/>
  </svg>
);

const BookmarkIcon = ({filled}) => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"}
       stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/>
  </svg>
);

const CloseIcon = () => (
  <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6 6 18M6 6l12 12"/>
  </svg>
);

const ChevronIcon = () => (
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6 9 6 6 6-6"/>
  </svg>
);

const PhoneIcon = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const MailIcon = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const CalendarIcon = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="18" x="3" y="4" rx="2"/>
    <path d="M16 2v4M8 2v4M3 10h18"/>
  </svg>
);

const ClockIcon = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 6v6l4 2"/>
  </svg>
);

const TagIcon = () => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/>
    <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>
  </svg>
);

const DetailItem = ({icon, label, value, dir}) => (
  <div className="mm-detail">
    <span className="mm-detail__icon">{icon}</span>
    <span className="mm-detail__label">{label}</span>
    <span className="mm-detail__value" dir={dir}>{value || "—"}</span>
  </div>
);

const MessagesModal = ({
                         onBookmark,
                         refreshMode,
                         setRefreshMode,
                         userType,
                       }) => {
  const {messageModal, feedbackId, setMessageModal} =
    useContext(MessageContext);

  const {auth, setRefreshNewCount} = useContext(GlobalStateContext);
  const [feedback, setFeedback] = useState({});
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [bookmark, setBookmark] = useState(false);
  const [senderOpen, setSenderOpen] = useState(false);
  const [subjectOpen, setSubjectOpen] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState([]);
  const [assignGroups, setAssignGroups] = useState([]);
  const [workflow, setWorkflow] = useState([]);
  const [pickupCloseBtnState, setPickupCloseBtnState] = useState(false);
  const [messageModalTabs, setMessageModalTabs] = useState("commentDetails");
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [showSharing, setShowSharing] = useState(false);
  const {t} = useTranslation();

  useEffect(() => {
    setMessageModalTabs("commentDetails");
    setSenderOpen(false);
    setSubjectOpen(false);
  }, [messageModal]);

  const show = useContext(ToastContext);

  const handleTabSelect = (tab) => {
    setMessageModalTabs(tab);
  };

  const handleBookmarkToggle = (event) => {
    event.stopPropagation();
    if (bookmark) {
      removeBookmark(bookmark.id, feedback.id).then(() => {
        setBookmark(false);
        onBookmark(feedbackId, false);
      });
    } else {
      addBookmark(feedback.id).then((response) => {
        setBookmark(response);
        onBookmark(feedbackId, response);
      });
    }
  };

  const getFeedbackItems = () => {
    if (!shouldFetchMessageDetail(messageModal, feedbackId)) {
      return;
    }
    setFeedbackStatus([]);
    setAssignGroups([]);
    setWorkflow([]);
    setFeedback({});
    setFiles([]);
    setLoading(true);
    getFeedback(feedbackId, userType === "user")
      .then((data) => {
        setFeedback(data);
        setFiles(collectFeedbackFiles(data));
        setBookmark(data.bookmark);
      })
      .catch(() => {
        setFeedback(null);
      })
      .finally(() => {
        setLoading(false);
      });
    get(FEEDBACK_STATUS_LIST.replace("{id}", feedbackId))
      .then((r) => {
        if (r.results.length > 0) {
          setFeedbackStatus(r.results);
        } else {
          setFeedbackStatus(undefined);
        }
        return r.results;
      })
      .then((p) => {
        if (p[0]?.status === 3) {
          get(
            FEEDBACK_STATUS_LIST_ASSIGN_GROUPS.replace(
              "{id}",
              p[0].id
            )
          )
            .then((r) => {
              setAssignGroups(r);
            })
            .catch(() => setAssignGroups([]));
        }
        if (p.length > 0 && userType === "organ")
          get(
            FEEDBACK_STATUS_WORKFLOW.replace(
              "{id}",
              p[0].feedback_status_workflow
            )
          ).then((r) => {
            setWorkflow(r);
          });
      })
      .catch(() => {
        setFeedbackStatus(undefined);
      });
  };

  useEffect(() => {
    getFeedbackItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedbackId, messageModal]);

  useEffect(() => {
    if (feedbackStatus)
      if (feedbackStatus[0]?.status === 3) {
        get(
          FEEDBACK_STATUS_LIST_ASSIGN_GROUPS.replace(
            "{id}",
            feedbackStatus[0].id
          )
        ).then((r) => {
          setAssignGroups(r);
          setPickupCloseBtnState(false);
        });
      }
  }, [feedbackStatus]);

  const closeModal = () => {
    setMessageModal(false);
    setLoading(true);
    setFeedback(null);
  };

  const handleLikeClick = (event) => {
    event.stopPropagation();
    likeFeedback(feedbackId).then(() => {
      show(
        t("Src.Pages.Messages.MessagesModal.Comment.Success"),
        "success"
      );
    });
  };

  const handleDisLikeClick = (event) => {
    event.stopPropagation();
    disLikeFeedback(feedbackId).then(() => {
      show(
        t("Src.Pages.Messages.MessagesModal.Comment.Success"),
        "success"
      );
    });
  };

  const pickupMessage = () => {
    setPickupCloseBtnState(true);
    post(FEEDBACK_STATUS_PICKUP.replace("{id}", feedbackStatus[0].id))
      .then((r) => {
        setFeedbackStatus([r.feedback_status]);
        show(
          t("Src.Pages.Messages.MessagesModal.RemoveSuccess"),
          "success",
          t("Src.Pages.Messages.MessagesModal.RemoveSuccess.Flag")
        );
        setRefreshNewCount((prevState) => !prevState);
        setPickupCloseBtnState(false);
        setRefreshMode(true);
        setShowSharing(true);
        getFeedbackItems();
      })
      .catch((e) => {
        show(
          t("Src.Pages.Messages.MessagesModal.RemoveDanger"),
          "danger",
          t("Src.Pages.Messages.MessagesModal.RemoveDanger.Flag")
        );
        setRefreshNewCount((prevState) => !prevState);
        setPickupCloseBtnState(false);
      });
  };

  const canCloseMessage = () => {
    let arr = [];
    if (Object.keys(workflow).length > 0)
      workflow.close_feedback_status_groups.forEach((r) => {
        arr.push(r.head.id);
        r.members.forEach((p) => {
          arr.push(p.id);
        });
      });
    return arr.some((p) => p === auth.id);
  };

  const closeMessageHandle = () => {
    setShowScoreModal(true);
  };

  const senderName =
    feedback?.user?.first_name || feedback?.user?.last_name
      ? `${feedback.user.first_name} ${feedback.user.last_name}`
      : t("Organizational.Messages.Guest.User");

  const itemScore = Math.round((feedback?.item?.computed_score || 0) * 100) / 100;

  const ready = isMessageDetailReady(loading, feedback);

  return (
    <>
      <Modal
        show={messageModal}
        onHide={closeModal}
        className="message_modal_v2"
        dialogClassName="mm-dialog"
        centered
        fullscreen="sm-down"
        animation={false}
      >
        <Modal.Body>
          {ready ? (
            <div className="mm-shell">
              <header className="mm-header">
                <div className="mm-header__lead">
                  <button
                    type="button"
                    className="mm-icon-btn"
                    onClick={closeModal}
                    aria-label={t("Src.Pages.Messages.UserMessageModal.Close.Btn")}
                  >
                    <CloseIcon/>
                  </button>
                  <div className="mm-header__title">
                    <h1>{t("Organizational.Messages.Message'sDetails.Window")}</h1>
                    <span className="mm-header__date">
                      <CalendarIcon/>
                      {moment(feedback.datetime).format("jYYYY/jMM/jDD")}
                      <span className="mm-dot"/>
                      <ClockIcon/>
                      {moment(feedback.datetime).format("HH:mm")}
                    </span>
                  </div>
                </div>
                <div className="mm-header__actions">
                  <button
                    type="button"
                    className="mm-vote mm-vote--up"
                    onClick={handleLikeClick}
                    aria-label="like"
                  >
                    <ThumbUpIcon/>
                    <span>{feedback.likes_count || 0}</span>
                  </button>
                  <button
                    type="button"
                    className="mm-vote mm-vote--down"
                    onClick={handleDisLikeClick}
                    aria-label="dislike"
                  >
                    <ThumbDownIcon/>
                    <span>{feedback.dislikes_count || 0}</span>
                  </button>
                  <button
                    type="button"
                    className={`mm-icon-btn mm-bookmark${bookmark ? " active" : ""}`}
                    onClick={handleBookmarkToggle}
                    aria-label="bookmark"
                  >
                    <BookmarkIcon filled={!!bookmark}/>
                  </button>
                  {feedbackStatus &&
                  feedbackStatus.length > 0 &&
                  feedbackStatus[0].pickup === true &&
                  (feedbackStatus[0].status === 1 ||
                    feedbackStatus[0].status === 2) ? (
                    <Button
                      className="mm-action-btn mm-action-btn--primary"
                      onClick={pickupMessage}
                      disabled={pickupCloseBtnState}
                    >
                      {pickupCloseBtnState ? (
                        <Spinner animation="border" size="sm"/>
                      ) : (
                        <span>
                          {t("Organizational.Messages.Remove.Button.Label")}
                        </span>
                      )}
                    </Button>
                  ) : null}
                  {feedbackStatus &&
                  feedbackStatus[0]?.status === 3 &&
                  canCloseMessage() ? (
                    <Button
                      className="mm-action-btn mm-action-btn--danger"
                      onClick={closeMessageHandle}
                      disabled={pickupCloseBtnState}
                    >
                      {pickupCloseBtnState ? (
                        <Spinner animation="border" size="sm"/>
                      ) : (
                        <span>
                          {t("Organizational.Messages.Close.Button.Label")}
                        </span>
                      )}
                    </Button>
                  ) : null}
                </div>
              </header>

              <div className="mm-body">
                <aside
                  className="mm-context"
                  aria-label={t("Organizational.Messages.Message'sDetails.Window")}
                >
                  <section className={`mm-card mm-subject${subjectOpen ? " open" : ""}`}>
                    <button
                      type="button"
                      className="mm-card__head"
                      aria-expanded={subjectOpen}
                      onClick={() => setSubjectOpen((open) => !open)}
                    >
                      <span
                        className="mm-card__thumb"
                        style={{
                          backgroundImage: `url(${feedback.item.photo || UserPic})`,
                        }}
                        role="img"
                        aria-label={feedback.item.name}
                      />
                      <span className="mm-card__id">
                        <span className="mm-card__label">
                          {t("Organizational.Messages.FeedbackSubject.Label")}
                        </span>
                        <span className="mm-card__value">{feedback.item.name}</span>
                        <span className="mm-card__sub">
                          {feedback.item.item_type_name}
                          {itemScore != null && (
                            <>
                              {" - "}
                              <span className="mm-card__score-inline">
                                {itemScore}
                                {" "}
                                {t("Src.Pages.Messages.Modals.CommentDetals.From")} 5
                              </span>
                            </>
                          )}
                        </span>
                      </span>
                      <span className="mm-card__chevron" aria-hidden="true">
                        <ChevronIcon/>
                      </span>
                    </button>
                    {subjectOpen ? (
                      <div className="mm-card__body mm-subject__body">
                        <div className="mm-subject__rating">
                          <div className="mm-subject__score">
                            <strong>{itemScore}</strong>
                            <span>
                              {t("Src.Pages.Messages.Modals.CommentDetals.From")} 5
                            </span>
                          </div>
                        </div>
                        {(feedback.item.features || []).length > 0 && (
                          <div className="mm-subject__features">
                            {feedback.item.features.map(({feature, value}, index) => (
                              <DetailItem
                                key={`${feature.name}-${index}`}
                                icon={<TagIcon/>}
                                label={feature.name}
                                value={value || "-"}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    ) : null}
                  </section>

                  <section className={`mm-card mm-sender${senderOpen ? " open" : ""}`}>
                    <button
                      type="button"
                      className="mm-card__head"
                      aria-expanded={senderOpen}
                      onClick={() => setSenderOpen((open) => !open)}
                    >
                      {feedback.user?.photo ? (
                        <span className="mm-card__avatar">
                          <span
                            className="mm-card__thumb mm-card__thumb--round"
                            style={{
                              backgroundImage: `url(${feedback.user.photo})`,
                            }}
                            role="img"
                            aria-label={senderName}
                          />
                        </span>
                      ) : null}
                      <span className="mm-card__id">
                        <span className="mm-card__label">
                          {t("Organizational.Messages.Sender.Label")}
                        </span>
                        <span className="mm-card__value">{senderName}</span>
                        <span className="mm-card__sub" dir="ltr">
                          {feedback.user?.phone_number}
                        </span>
                      </span>
                      <span className="mm-card__chevron" aria-hidden="true">
                        <ChevronIcon/>
                      </span>
                    </button>
                    {senderOpen ? (
                      <div className="mm-card__body">
                        <DetailItem
                          icon={<PhoneIcon/>}
                          label={t("Src.Pages.Messages.UserMessageModal.Phone", "تلفن")}
                          value={feedback.user?.phone_number}
                          dir="ltr"
                        />
                        {feedback.user?.email ? (
                          <DetailItem
                            icon={<MailIcon/>}
                            label={t("Src.Pages.Messages.UserMessageModal.Email", "ایمیل")}
                            value={feedback.user.email}
                            dir="ltr"
                          />
                        ) : null}
                        <DetailItem
                          icon={<TagIcon/>}
                          label={t("Organizational.Messages.UserGroup.Label")}
                          value={feedback.user?.user_level}
                        />
                        {(feedback.features || []).map(({feature, value}, index) => (
                          <DetailItem
                            key={`${feature.name}-${index}`}
                            icon={<TagIcon/>}
                            label={feature.name}
                            value={value}
                          />
                        ))}
                      </div>
                    ) : null}
                  </section>
                </aside>

                <main className="mm-main">
                  <Tab.Container
                    activeKey={messageModalTabs}
                    onSelect={handleTabSelect}
                  >
                    <div className="mm-tabs-sticky">
                      <Nav variant="tabs" className="mm-tabs">
                        <Nav.Item>
                          <Nav.Link eventKey="commentDetails">
                            {t("Src.Pages.Messages.MessagesModal.Tab.commentDetails")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="images">
                            <span className="mm-tab-title">
                              {t("Organizational.Messages.Pictures.Tab")}
                              {files.length > 0 && (
                                <span className="mm-tab-badge">{files.length}</span>
                              )}
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                        {feedbackStatus && (
                          <Nav.Item>
                            <Nav.Link eventKey="report">
                              {t("Organizational.Messages.AutomationReport.Tab")}
                            </Nav.Link>
                          </Nav.Item>
                        )}
                        {feedbackStatus &&
                          feedbackStatus[0]?.status === 3 &&
                          assignGroups[0] && (
                            <Nav.Item>
                              <Nav.Link eventKey="sharing">
                                {t("Organizational.Messages.Sharing.Tab")}
                              </Nav.Link>
                            </Nav.Item>
                          )}
                      </Nav>
                    </div>
                    <Tab.Content>
                      <Tab.Pane eventKey="commentDetails" transition={false}>
                        <div className="mm-tabpane">
                          <CommentDetals
                            id={feedback.id}
                            file={feedback.file}
                            senderName={senderName}
                            criteria={feedback.criteria_replies}
                            computed_score={feedback.computed_score}
                            score={feedback.score}
                            description={feedback.description}
                            voice={feedback.voice}
                            dateTime={feedback.datetime}
                            ai={feedback.sentiment_analysis}
                          />
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="images" transition={false}>
                        <div className="mm-tabpane">
                          {messageModalTabs === "images" && (
                            <SendingPictures files={files}/>
                          )}
                        </div>
                      </Tab.Pane>
                      {feedbackStatus && (
                        <Tab.Pane eventKey="report" transition={false}>
                          <div className="mm-tabpane">
                            {messageModalTabs === "report" && (
                              <Report
                                userType={userType}
                                feedbackId={feedbackStatus[0]?.id}
                              />
                            )}
                          </div>
                        </Tab.Pane>
                      )}
                      {feedbackStatus &&
                        feedbackStatus[0]?.status === 3 &&
                        assignGroups[0] && (
                          <Tab.Pane eventKey="sharing" transition={false}>
                            <div className="mm-tabpane">
                              {messageModalTabs === "sharing" && (
                                <Sharing
                                  feedbackStatusId={feedbackStatus[0].id}
                                  assignGroups={assignGroups}
                                  setAssignGroups={setAssignGroups}
                                  setMessageModalTabs={setMessageModalTabs}
                                />
                              )}
                            </div>
                          </Tab.Pane>
                        )}
                    </Tab.Content>
                  </Tab.Container>
                </main>
              </div>
            </div>
          ) : (
            <div className="mm-loader">
              <Spinner animation="border"/>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <ScoreModal
        showModal={showScoreModal}
        setShowScoreModal={setShowScoreModal}
        feedbackId={feedbackStatus ? feedbackStatus[0]?.id : undefined}
        groupId={
          feedbackStatus ? feedbackStatus[0]?.group?.id : undefined
        }
        setPickupCloseBtnState={setPickupCloseBtnState}
        setFeedbackStatus={setFeedbackStatus}
        setMessageModalTabs={setMessageModalTabs}
        setAssignGroups={setAssignGroups}
        setRefreshMode={setRefreshMode}
      />
    </>
  );
};

export default MessagesModal;
